import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TstrApi from 'Apis/tstrApi';

type GuardStatus = 'checking' | 'allowed';

type PageGuardProps = {
    children: React.ReactNode;
    tstKindCd: string;
    redirectTo?: string;
};

function PageGuard({ children, tstKindCd, redirectTo = '/' }: PageGuardProps) {
    const [status, setStatus] = useState<GuardStatus>('checking');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        let isActive = true;

        const runGuard = async () => {
            try {
                const searchParams = new URLSearchParams(location.search);
                const gameSvcCd = (searchParams.get('gameSvcCd') || 'BBO').toUpperCase();
                await TstrApi(gameSvcCd, tstKindCd);
                if (isActive) {
                    setStatus('allowed');
                }
            } catch (err) {
                if (isActive) {
                    navigate(redirectTo, { replace: true });
                }
            }
        };

        runGuard();

        return () => {
            isActive = false;
        };
    }, [location.search, navigate, redirectTo, tstKindCd]);

    if (status !== 'allowed') {
        return null;
    }

    return <>{children}</>;
}

export default PageGuard;